var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("main", { staticClass: "map-container view-container view-body" }, [
    _c("div", { ref: "map", staticClass: "view-body" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }